import { createRouter, createWebHistory } from 'vue-router' 
// Componentes críticos que se cargan inmediatamente
import CognitoCallback from '@/components/CognitoCallback.vue'
import MobileLayoutView from '@/views/MobileLayoutView.vue'

// Lazy loading - Los componentes se cargan solo cuando se necesitan
const NewAccount = () => import('@/views/NewAccount.vue')
const NotFoundView = () => import('@/views/NotFoundView.vue')
const InputPassView = () => import('@/views/InputPassView.vue')
const ActiveTable = () => import('@/components/tables/ActiveTable.vue')
const HistoryTable = () => import('@/components/tables/HistoryTable.vue')
const SuccessOpenView = () => import('@/views/SuccessOpenView.vue')
const FailureOpenView = () => import('@/views/FailureOpenView.vue')
const SpentCodeView = () => import('@/views/SpentCodeView.vue')
const InvitationView = () => import('@/views/InvitationView.vue')
const AdminMenu = () => import('@/components/menus/AdminMenu.vue')
const MobileMenu = () => import('@/components/menus/MobileMenu.vue')
const OpenLocker = () => import('@/components/OpenLocker.vue')
const ScheduleComponent = () => import('@/components/ScheduleComponent.vue')
const UnauthorizedView = () => import('@/views/UnauthorizedView.vue')
const PasswordChanger = () => import('@/components/forms/ChangePasswordForm.vue')
const finishRegister = () => import('@/components/forms/FinishRegister.vue')
const MailSender = () => import('@/components/MailSender.vue')
const BookingUniversalBoard = () => import('@/components/boards/BookingUniversalBoard.vue')
const BookingBuildingBoard = () => import('@/components/boards/BookingBuildingBoard.vue')
const QuickOpening = () => import('@/components/boards/QuickOpening.vue')
const FastBooking = () => import('@/components/boards/FastBooking.vue')
const DevicesStatus = () => import('@/components/DevicesStatus.vue')
const RedirectDeliveryVue = () => import('@/components/delivery/RedirectDelivery.vue')
const RedirectDeliveryLegacyVue = () => import('@/components/delivery/RedirectDeliveryLegacy.vue')
const StartWithQrVue = () => import('@/components/delivery/StartWithQr.vue')
const NotificationServices = () => import('@/components/NotificationServices.vue')
const WspSender = () => import('@/components/WspSender.vue')
const RedirectWsp = () => import('@/components/delivery/RedirectWsp.vue')
const LockerOffLineView = () => import('@/views/LockerOffLineView.vue')
const UsersAdmin = () => import('@/components/boards/UsersAdmin.vue')
const AdminRacks = () => import('@/components/boards/AdminRacks.vue')
const AdminInstallations = () => import('@/components/boards/AdminInstallations.vue')
const AdminDevices = () => import('@/components/boards/AdminDevices.vue')
const AdminQRs = () => import('@/components/boards/AdminQRs.vue')
const AdminLockers = () => import('@/components/boards/AdminLockers.vue')
const AdminInfrastructure = () => import('@/components/boards/AdminInfrastructure.vue')
const AdminCoupons = () => import('@/components/boards/AdminCoupons.vue')
const AdminAudit = () => import('@/components/boards/AdminAudit.vue')
const AdminAdmins = () => import('@/components/boards/AdminAdmins.vue')
const AdminLocalAccess = () => import('@/components/boards/AdminLocalAccess.vue')

import Auth from './middleware/auth.js'
import Rbac from './middleware/Rbac.js'
import RbacDelivery from './middleware/RbacDelivery.js'
import { config } from '@/utils/cognitoConfig.js'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: CognitoCallback,
    beforeEnter: () => {
      // Si hay tokens en el hash (callback de Cognito), permitir que el componente los procese
      if (window.location.hash.includes('access_token')) {
        return true
      }
      // Si no hay tokens, redirigir directamente a Cognito (login)
      window.location.href = config.getLoginUrl()
      // Cancelar la navegación interna porque ya estamos redirigiendo
      return false
    }
  },
  {
    path: '/inst/:qr',
    name: 'RedirectDelivery',
    component: RedirectDeliveryVue
  },
  {
    path: '/inst/legacy/:qr',
    name: 'RedirectDeliveryLegacy',
    component: RedirectDeliveryLegacyVue
  },
  {
    path: '/redirect/:nro',
    name: 'RedirectWsp',
    component: RedirectWsp
  },
  {
    path: '/:id/:name/:device',
    name: 'StartWithQrVue',
    component: StartWithQrVue
  },
  {
    path: '/login',
    name: 'Login',
    beforeEnter: () => {
      // Redirigir a Cognito usando la configuración dinámica
      window.location.href = config.getLoginUrl()
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error 404',
    component: NotFoundView
  },
  {
    path: '/open',
    name: 'InputPassView',
    component: InputPassView,
    props: true
  },
  {
    path: '/unauthorized',
    name: 'UnauthorizedView',
    component: UnauthorizedView
  },
  {
    path: '/register',
    name: 'NewAccount',
    component: NewAccount
  },
  {
    path: '/menu',
    name: 'MobileLayoutView',
    component: MobileLayoutView,
    meta: {
      reqAuth: true
    },
    children: [
      { path: '', name: 'HomeMenuView', component: MobileMenu },
      { path: 'newpassword', name: 'PassWordChanger', component: PasswordChanger },
      { path: 'rent', name: 'ReservationView', component: OpenLocker },
      { path: 'active', name: 'ActiveTable', component: ActiveTable },
      { path: 'history', name: 'HistoryView', component: HistoryTable },
      { path: 'admin', name: 'AdminMenuView', meta: { rbac: true }, component: AdminMenu },
      { path: 'bookings', name: 'ReservationUniversalView', meta: { rbac: true }, component: BookingUniversalBoard },
      { path: 'quickopening', name: 'QuickOpeningView', meta: { rbac: true }, component: QuickOpening },
      { path: 'fast-booking', name: 'FastBookingView', component: FastBooking },
      { path: 'building', name: 'ReservationBuildingView', meta: { rbacBuilding: true }, component: BookingBuildingBoard },
      { path: 'admin/services', name: 'NotificationServices', meta: { rbac: true }, component: NotificationServices },
      { path: 'admin/services/wsp', name: 'WspSender', meta: { rbac: true }, component: WspSender },
      { path: 'admin/services/mail', name: 'MailSender', meta: { rbac: true }, component: MailSender },
      { path: 'admin/devices', name: 'DevicesStatus', meta: { rbac: true }, component: DevicesStatus},
      { path: 'admin/users', name: 'UsersAdmin', meta: { rbac: true }, component: UsersAdmin},
      { path: 'admin/racks', name: 'AdminRacks', meta: { rbac: true }, component: AdminRacks},
      { path: 'admin/installations', name: 'AdminInstallations', meta: { rbac: true }, component: AdminInstallations},
      { path: 'admin/devices-board', name: 'AdminDevices', meta: { rbac: true }, component: AdminDevices},
      { path: 'admin/qrs', name: 'AdminQRs', meta: { rbac: true }, component: AdminQRs},
      { path: 'admin/lockers', name: 'AdminLockers', meta: { rbac: true }, component: AdminLockers},
      { path: 'admin/infrastructure', name: 'AdminInfrastructure', meta: { rbac: true }, component: AdminInfrastructure},
      { path: 'admin/coupons', name: 'AdminCoupons', meta: { rbac: true }, component: AdminCoupons},
      { path: 'admin/audit', name: 'AdminAudit', meta: { rbac: true }, component: AdminAudit},
      { path: 'admin/admins', name: 'AdminAdmins', meta: { rbac: true }, component: AdminAdmins},
      { path: 'admin/local-access', name: 'AdminLocalAccess', meta: { rbac: true }, component: AdminLocalAccess},
      { path: 'schedule', name: 'ScheduleView', component: ScheduleComponent },
      { path: 'finishInfo', name: 'finishRegister', component: finishRegister }

    ]
  },
  {
    path: '/open/success',
    name: 'SuccessOpenView',
    props: true,
    component: SuccessOpenView
  },
  {
    path: '/open/failure',
    name: 'FailureOpenView',
    props: true,
    component: FailureOpenView
  },
  {
    path: '/open/spent',
    name: 'SpentCodeView',
    props: true,
    component: SpentCodeView
  },
  {
    path: '/open/offline',
    name: 'LockerOffLineView',
    props: true,
    component: LockerOffLineView
  },
  {
    path: '/open/invitation',
    name: 'InvitationView',
    props: true,
    component: InvitationView
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  if (to.meta.reqAuth && !Auth()) return true
  if (to.meta.rbac) Rbac()
  if (to.meta.rbacDelivery) RbacDelivery()
  return true
})

router.afterEach((to) => {
  try {
    if (to.path.startsWith('/menu') && localStorage.getItem('token')) {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('cognito-auth-complete'))
      }, 80)
    }
  } catch (e) {
    // silent
  }
})

// When a lazy-loaded chunk fails during navigation (stale deploy), redirect to the
// target route after a full reload so the browser fetches updated chunk URLs.
// main.js has a complementary unhandledrejection handler for cases outside navigation.
router.onError((error, to) => {
  const isChunkError =
    error?.name === 'ChunkLoadError' ||
    /loading chunk \d+ failed/i.test(error?.message || '') ||
    /loading css chunk \d+ failed/i.test(error?.message || '')

  if (!isChunkError) return

  const RELOAD_KEY = 'chunk_reload_attempted'
  if (sessionStorage.getItem(RELOAD_KEY)) {
    sessionStorage.removeItem(RELOAD_KEY)
    return
  }
  sessionStorage.setItem(RELOAD_KEY, '1')
  window.location.assign(to?.fullPath ?? window.location.pathname)
})

export default router
